'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rangePropType;

var _utils = require('../utils');

/**
 * @ignore
 * @param {Object} props - React component props
 * @return {?Error} Return Error if validation fails
 */
function rangePropType(props) {
  var maxValue = props.maxValue,
      minValue = props.minValue;


  if (!(0, _utils.isNumber)(minValue) || !(0, _utils.isNumber)(maxValue)) {
    return new Error('"minValue" and "maxValue" must be a number');
  }

  if (minValue >= maxValue) {
    return new Error('"minValue" must be smaller than "maxValue"');
  }
}
module.exports = exports['default'];
//# sourceMappingURL=range-prop-type.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-input-range/lib/js/input-range/range-prop-type.js
// module id = 1299
// module chunks = 0